import { FiSearch } from 'react-icons/fi'

// SearchInput — pill con icono search y kbd hint opcional.

export default function SearchInput({
  placeholder = 'Buscar…',
  value,
  onChange,
  kbd,
  className = '',
  ...rest
}) {
  return (
    <div className={`flex items-center gap-2 h-9 px-3 rounded-pill bg-[var(--bg-2)] border border-[var(--line)] text-[13px] focus-within:border-[var(--ink-3)] transition-colors ${className}`}>
      <FiSearch size={14} className="text-[var(--ink-3)] flex-shrink-0" />
      <input
        type="search"
        className="flex-1 bg-transparent outline-none placeholder:text-[var(--ink-4)] min-w-0"
        placeholder={placeholder}
        value={value ?? ''}
        onChange={e => onChange?.(e.target.value)}
        {...rest}
      />
      {kbd && <span className="kbd flex-shrink-0">{kbd}</span>}
    </div>
  )
}
